export const IDS = {
  SECTION: 'footer',
} as const;

export const TEXT = {
  CLAIM: {id: 'home.footerclaim', defaultMessage: 'Fashion that fits you.'},
  COPYRIGHT: {id: 'navigation.footer.copyright', defaultMessage: 'All rights reserved © {year}'},
} as const;
